import { _makeInstalledApp } from '@atlassian/mpac-spi';
import { Option } from 'funfix-core';
import { Record } from 'immutable';
import { makeInstallableAppByKeyIdentifier } from '../InstallableAppIdentifier';
import { makePendingConfirmationInstallStatus } from './InstallStatus';
export const INSTALLABLE_APP_UPGRADE_INSTALL_MODE = 'INSTALLABLE_APP_UPGRADE';
export const makeInstallableAppUpgradeInstallMode = Record({
  type: INSTALLABLE_APP_UPGRADE_INSTALL_MODE,
  installableAppByKeyId: makeInstallableAppByKeyIdentifier(),
  installableAppToUpgradeTo: Option.empty(),
  installedApp: _makeInstalledApp(),
  retrievalId: 0,
  status: makePendingConfirmationInstallStatus()
});